import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { paths, permissions } from 'src/paths';
import { getEpisodeOfCare } from 'src/redux/actions/patientEpisodeOfCare';
import { getScreening } from 'src/redux/actions/patientScreening';
import { EpisodeOfCareTable } from './episode-of-care-table';
import { FacilityStayTable } from './facility-stay-table';
import { ScreeningsTable } from './screening-table';

type Props = {
  patientId: string;
};
const { UPDATE_PATIENT, READ_EPISODE_OF_CARE, READ_SCREENINGS } = permissions;

const { patients, editPatient } = paths;

export const formatContactNumber = (value: string) => {
  if (value === null) {
    return {
      formattedValue: '',
      cleanedValue: '',
    };
  }

  const cleanedValue = value?.replace(/[^\d+]/g, '');

  const pattern = /^(\+\d{1,3})?(\d{3})?(\d{3})(\d{4})$/;

  const formattedValue = cleanedValue?.replace(pattern, (match, p1, p2, p3, p4) => {
    if (p2 && p3) {
      if (p1) {
        return `${p1} (${p2})-${p3}-${p4}`;
      } else {
        return `(${p2})-${p3}-${p4}`;
      }
    } else {
      return cleanedValue;
    }
  });

  return {
    formattedValue,
    cleanedValue,
  };
};

function PatientInfo({ patientId }: Props) {
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const screeningData = useSelector((state: any) => state?.getScreeningReducer?.response);
  const episodeOfCareData = useSelector((state: any) => state?.getEpisodeOfCare?.response);
  const facilityStayData = useSelector((state: any) => state?.getAllFacilitiesStaysReducer);
  const patientDataLoader = useSelector((state: any) => state.getSinglePatientReducer);
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );

  const patientDob = patientData?.dateOfBirth && patientData?.dateOfBirth?.split('T')?.at(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getScreening({ patientId }));
  }, []);

  useEffect(() => {
    dispatch(
      getEpisodeOfCare({
        patientId,
      })
    );
  }, []);

  return (
    <>
      {/* <Grid
        container
        flexDirection={'row'}
        justifyContent={'space-between'}
      >
        <Grid
          display={'flex'}
          alignItems={'center'}
        >
          <Typography variant="body1">Personal Info</Typography>
        </Grid>
        <Grid>
          <Button
            color="inherit"
            startIcon={
              <SvgIcon>
                <Edit />
              </SvgIcon>
            }
            onClick={(event) =>
              navigate(`${patients}${editPatient}`, {
                state: {
                  patientId,
                  patientData,
                },
              })
            }
            disabled={!permissionData?.includes(UPDATE_PATIENT)}
            sx={{ color: 'primary.dark' }}
          >
            Edit Details
          </Button>
        </Grid>
      </Grid>
      <Box> */}
      {/* <Grid
          container
          display={'flex'}
          flexWrap={'nowrap'}
          justifyContent={'space-between'}
        >
          <Grid xs={6.7}>
            {!patientDataLoader?.loading ? (
              <Card>
                <Grid
                  display={'flex'}
                  flexDirection={'row'}
                >
                  <Box flex={1}>
                    <CardHeader
                      sx={{ pb: 0 }}
                      title="Basic Details"
                    />
                    <CardContent>
                      <Typography variant="subtitle2">Activation Status</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {patientData?.active ? 'Active' : 'Inactive'}
                      </Typography>
                      <Typography variant="subtitle2">Gender</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{
                          mb: 2,
                          textTransform: 'capitalize',
                        }}
                        variant="body2"
                      >
                        {patientData?.gender ? patientData?.gender?.toLowerCase() : '-'}
                      </Typography>

                      <Typography variant="subtitle2">Date Of Birth</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {patientData?.dateOfBirth
                          ? format(
                              new Date(
                                new Date(patientDob).valueOf() +
                                  new Date(patientDob).getTimezoneOffset() * 60 * 1000
                              ),
                              'MMM dd, yyyy'
                            )
                          : '-'}
                      </Typography>

                      <Typography variant="subtitle2">Phone Number</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {patientData?.patientPhoneNo
                          ? formatContactNumber(patientData?.patientPhoneNo).formattedValue
                          : '-'}
                      </Typography>
                      <Typography variant="subtitle2">Email</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {patientData?.patientEmail ? patientData?.patientEmail : '-'}
                      </Typography>
                    </CardContent>
                  </Box>
                  <Divider
                    orientation="vertical"
                    flexItem
                  />
                  <Box flex={1}>
                    <CardHeader
                      sx={{ pb: 0 }}
                      title="Therapy Details"
                    />

                    <CardContent>
                      <Typography variant="subtitle2">Primary Physician</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {patientData?.physicianEntitySet &&
                        patientData?.physicianEntitySet?.length !== 0
                          ? patientData?.physicianEntitySet
                              ?.map((physician: any) => physician.physicianName)
                              .join('')
                          : '-'}
                      </Typography>

                      <Typography variant="subtitle2">Medical Record Number</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {patientData?.medicalRecordNumber ? patientData?.medicalRecordNumber : '-'}
                      </Typography>

                      <Typography variant="subtitle2">Social Security Number</Typography>
                      <Typography
                        color="text.secondary"
                        sx={{ mb: 2 }}
                        variant="body2"
                      >
                        {patientData?.socialSecurityNumber
                          ? patientData?.socialSecurityNumber
                              ?.toString()
                              ?.replace(/^(\d{5})(\d{4})$/, 'XXX-XX-$2')
                          : '-'}
                      </Typography>
                    </CardContent>
                  </Box>
                </Grid>
              </Card>
            ) : (
              <Card>
                <Grid
                  display={'flex'}
                  flexDirection={'row'}
                >
                  <Box flex={1}>
                    <CardHeader
                      sx={{ pb: 0 }}
                      title="Basic Details"
                    />
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>

                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>

                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                    </CardContent>
                  </Box>
                  <Divider
                    orientation="vertical"
                    flexItem
                  />
                  <Box flex={1}>
                    <CardHeader
                      sx={{ pb: 0 }}
                      title="Therapy Details"
                    />
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>

                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>

                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                      <Typography
                        width={'45%'}
                        variant="h5"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                    </CardContent>
                  </Box>
                </Grid>
              </Card>
            )}
          </Grid> */}
      {/* Facility Wide Activity */}
      {/* <Grid
            xs={12}
            md={5}
          >
            <Card
              sx={{
                height: '100%',
                width: '100%',
                backgroundColor: '#e4e5ff80',
              }}
            >
              <Stack
                alignItems="center"
                flexDirection="row"
                gap="1rem"
                sx={{ margin: '1.5rem 0 0 1.5rem' }}
              >
                <img
                  src={starIcon}
                  width="30px"
                  height="30px"
                  alt=""
                />
                <Typography
                  variant="h6"
                  sx={{ color: '#4338CA' }}
                >
                  Facility Wide Activity
                </Typography>
              </Stack>
              <Stack>
                <Grid sx={{ margin: '1.5rem 0 0 1.5rem' }}>
                  <Typography
                    color="text.secondary"
                    variant="body2"
                  >
                    Wellness
                  </Typography>
                  <Grid
                    container
                    display={'flex'}
                    flexDirection={'row'}
                    padding={'10px 0px'}
                  >
                    <Grid xs={6}>
                      <Typography variant="subtitle2">Week-over-week-Trend</Typography>
                    </Grid>
                    <Grid xs={6}>
                      <Typography
                        color="#15B79E"
                        variant="body2"
                      >
                        Up
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    display={'flex'}
                    flexDirection={'row'}
                    padding={'10px 0px'}
                  >
                    <Grid xs={6}>
                      <Typography variant="subtitle2">Last Wellness Session</Typography>
                    </Grid>
                    <Grid xs={6}>
                      <Typography
                        color="text.secondary"
                        variant="body2"
                      >
                        Aug 22, 2022
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider sx={{ backgroundColor: '#E5E7EB' }} />
                <Grid sx={{ margin: '1.5rem 0 0 1.5rem' }}>
                  <Typography
                    color="text.secondary"
                    variant="body2"
                  >
                    Restorative Program
                  </Typography>
                  <Grid
                    container
                    display={'flex'}
                    flexDirection={'row'}
                    padding={'10px 0px'}
                  >
                    <Grid
                      xs={6}
                      display={'flex'}
                      alignItems={'center'}
                    >
                      <Typography variant="subtitle2">Passive ROM</Typography>
                    </Grid>
                    <Grid xs={6}>
                      <Typography
                        color="text.secondary"
                        variant="body2"
                      >
                        <Button sx={{ padding: '0' }}>View Plan</Button>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    display={'flex'}
                    flexDirection={'row'}
                    padding={'10px 0px'}
                  >
                    <Grid xs={6}>
                      <Typography variant="subtitle2">Last Participation</Typography>
                    </Grid>
                    <Grid xs={6}>
                      <Typography
                        color="text.secondary"
                        variant="body2"
                      >
                        Aug 22, 2022
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Stack> */}
      {/* <Table sx={{ marginLeft: '8px' }}>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none', paddingBottom: '0px' }}>
                        <Typography
                          color="text.secondary"
                          variant="body2"
                        >
                          Wellness
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none',padding:"20px 10px" }}>
                        <Typography variant="subtitle2">Week-over-week-Trend</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          color="text.secondary"
                          variant="body2"
                        >
                          Up
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle2">Last Wellness Session</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          color="text.secondary"
                          variant="body2"
                        >
                          22 Aug 2022
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Divider sx={{ backgroundColor: '#E5E7EB', height: '3px' }} />
                      </TableCell>
                      <TableCell>
                        <Divider sx={{ backgroundColor: '#E5E7EB', height: '3px' }} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none', paddingBottom: '0px' }}>
                        <Typography
                          color="text.secondary"
                          variant="body2"
                        >
                          Restorative Program
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        <Typography variant="subtitle2">Passive ROM</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          color="text.secondary"
                          variant="body2"
                        >
                          <Button>View Plan</Button>
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        <Typography variant="subtitle2">Last Participation</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          color="text.secondary"
                          variant="body2"
                        >
                          22 Aug 2022
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table> */}
      {/* </Card> */}
      {/* </Container> */}
      {/* </Grid> */}
      {/* </Grid>
      </Box> */}

      {/* Epidose of care */}
      {permissionData?.includes(READ_EPISODE_OF_CARE) && (
        <EpisodeOfCareTable episodeOfCareData={episodeOfCareData?.content} />
      )}

      {/* Screenings Table */}
      {permissionData?.includes(READ_SCREENINGS) && (
        <ScreeningsTable screeningData={screeningData?.content} />
      )}

      {/* Facility stay table */}
      <FacilityStayTable
        patientId={patientId}
        patientData={patientData}
      />
    </>
  );
}

export default PatientInfo;
